// TileManipulationHelper is a static class that has methods that manipulate
// other tile models. None of the manipulation work is actually done in here,
// but TileManipulationHelper will unwrap generic Tile models and call the
// specific models' manipulation methods to do the work.

import ConveyorTile, { rotateConveyorTile } from 'app/src/engine/tiles/ConveyorTile';
import EmptyFloorTile, { rotateEmptyFloorTile } from 'app/src/engine/tiles/EmptyFloorTile';
import GearTile, { rotateGearTile } from 'app/src/engine/tiles/GearTile';
import PitTile, { rotatePitTile } from 'app/src/engine/tiles/PitTile';
import Tile from 'app/src/engine/tiles/Tile';

export default class TileManipulationHelper {
	public static getRotatedTile(tile: Tile, clockwise: boolean): Tile {
		// Check the tile type and call its custom rotator.
		if (tile instanceof EmptyFloorTile) {
			return rotateEmptyFloorTile(tile, clockwise);
		} else if (tile instanceof PitTile) {
			return rotatePitTile(tile, clockwise);
		} else if (tile instanceof GearTile) {
			return rotateGearTile(tile, clockwise);
		} else if (tile instanceof ConveyorTile) {
			return rotateConveyorTile(tile, clockwise);
		}

		// We don't have a rotator for this tile type.
		return tile;
	}
}
